@if (buttonVisible) {
  <button
    [id]="buttonId"
    class="actionBar__right"
    (click)="showMoreOptions()"
    ppTooltip
    [ppTitle]="'more_options' | ppTranslate"
    data-test="threeDotsButton"
  >
    <pp-icon
      ppClass="setSize18"
      ppColor="grey-500"
      [ppSVG]="iconMap[EIconPath.ICON_NAV_THREE_DOTS_VERTICAL_18]"
    />
  </button>
}
